import { looksLikeDMY, toISOFromDMY } from '../utils/date.js';

const RELEASE_SEEN_STORAGE_KEY = 'nautilusLastSeenReleaseId';

function normalizeReleaseDate(dateStr) {
    if (!dateStr) return 0;
    const normalized = looksLikeDMY(dateStr) ? toISOFromDMY(dateStr) : dateStr;
    const time = Date.parse(normalized);
    return Number.isNaN(time) ? 0 : time;
}

export function getSortedReleaseNotes() {
    const list = Array.isArray(RELEASE_NOTES) ? [...RELEASE_NOTES] : [];
    return list.sort((a, b) => normalizeReleaseDate(b.date) - normalizeReleaseDate(a.date));
}

export function getLatestReleaseNote() {
    const list = getSortedReleaseNotes();
    return list[0] || null;
}

export function getLastSeenReleaseId() {
    try {
        return localStorage.getItem(RELEASE_SEEN_STORAGE_KEY) || '';
    } catch (e) {
        return '';
    }
}

export function setLastSeenReleaseId(releaseId) {
    if (!releaseId) return;
    try {
        localStorage.setItem(RELEASE_SEEN_STORAGE_KEY, releaseId);
    } catch (e) {}
}

export const RELEASE_NOTES = [
    {
        id: "2026.01.06",
        version: "2.7.0",
        title: {
            en: "Signal and Flow",
            es: "Señal y flujo"
        },
        date: "2026-01-06",
        summary: {
            en: "A focused release that makes changes visible and deadlines clearer.",
            es: "Una versión enfocada que hace visibles los cambios y aclara los plazos."
        },
        sections: {
            new: [
                {
                    en: "Release Notes page with a clean breakdown of changes.",
                    es: "Página de notas de versión con un desglose claro de cambios."
                },
                {
                    en: "Top bar notification bell for new releases.",
                    es: "Campana de notificaciones en la barra superior para nuevas versiones."
                },
                {
                    en: "Due today reminders with quick navigation.",
                    es: "Recordatorios de vencimiento hoy con navegación rápida."
                }
            ],
            improvements: [
                {
                    en: "Updates page tuned for fast scanning.",
                    es: "Página de novedades ajustada para lectura rápida."
                },
                {
                    en: "Notification badge aggregates releases and due today tasks.",
                    es: "La insignia de notificaciones agrupa versiones y tareas que vencen hoy."
                },
                {
                    en: "Release dates formatted per locale.",
                    es: "Fechas de versión formateadas según la configuración regional."
                }
            ],
            fixes: [
                {
                    en: "Notifications now stay focused on tasks due today.",
                    es: "Las notificaciones ahora se enfocan en tareas que vencen hoy."
                },
                {
                    en: "Release history stays consistent across sessions.",
                    es: "El historial de versiones se mantiene consistente entre sesiones."
                }
            ]
        }
    },
    {
        id: "2025.12.20",
        version: "2.6.1",
        title: {
            en: "Stability Pass",
            es: "Pase de estabilidad"
        },
        date: "2025-12-20",
        summary: {
            en: "Polish across projects, tasks, and reporting.",
            es: "Pulido en proyectos, tareas y reportes."
        },
        sections: {
            new: [
                {
                    en: "Task sorting refinements in list view.",
                    es: "Mejoras en el ordenamiento de tareas en vista de lista."
                },
                {
                    en: "Improved history timeline labels.",
                    es: "Etiquetas mejoradas en la línea de tiempo del historial."
                }
            ],
            improvements: [
                {
                    en: "Cleaner spacing for project detail views.",
                    es: "Espaciado más limpio en vistas de detalle de proyecto."
                },
                {
                    en: "Faster dashboard rendering on large datasets.",
                    es: "Renderizado del panel más rápido con datos grandes."
                }
            ],
            fixes: [
                {
                    en: "Resolved occasional drag reorder glitches.",
                    es: "Corregidos fallos ocasionales al reordenar arrastrando."
                },
                {
                    en: "Fixed missing labels in calendar tooltips.",
                    es: "Corregidas etiquetas faltantes en los tooltips del calendario."
                }
            ]
        }
    },
    {
        id: "2025.12.04",
        version: "2.6.0",
        title: {
            en: "Project Clarity",
            es: "Claridad de proyecto"
        },
        date: "2025-12-04",
        summary: {
            en: "Better project visibility and smarter filters.",
            es: "Mejor visibilidad de proyectos y filtros más inteligentes."
        },
        sections: {
            new: [
                {
                    en: "Enhanced project filters for recency.",
                    es: "Filtros de proyectos mejorados por recencia."
                },
                {
                    en: "Quick access backlog button in Kanban.",
                    es: "Botón de acceso rápido al backlog en Kanban."
                }
            ],
            improvements: [
                {
                    en: "Refined status badges for contrast.",
                    es: "Insignias de estado refinadas para mejor contraste."
                },
                {
                    en: "Clearer labels across filters and chips.",
                    es: "Etiquetas más claras en filtros y chips."
                }
            ],
            fixes: [
                {
                    en: "Fixed filter chips not clearing on reset.",
                    es: "Corregido que los chips de filtros no se limpiaban al restablecer."
                },
                {
                    en: "Resolved layout shifts in mobile task list.",
                    es: "Corregidos saltos de diseño en la lista de tareas móvil."
                }
            ]
        }
    }
];
